<div class="container-box">
  <!-- <app-breadcrumb [breadCrumbs]="breadCrumbs"></app-breadcrumb>-->
  <div class="row">
    <div class="col-sm-12 col-md-6 col-md-offset-3 break-text">
      <h1>Edit user details</h1>
      <!-- Error Block -->
      <div class="alert valign-children-middle" *ngIf='setError'>
        <div class="alert-error" aria-label="Alert.">
          <i class="icon-badgealert" aria-hidden="true"></i>
        </div>

        <div>
          <h2 *ngIf='emailFlag'>Email already in use</h2>
          {{ErrorMessage}}
        </div>
      </div>
      <!-- Error Block End -->
      <form [formGroup]="userEditform" class='user-input-container' autocomplete="off">
        <div class='form-group'>
          <label class="col-sm-12 col-md-8" for='firstname' [ngClass]="{'error-field': formErrors.firstName}">First name</label>          <br>
          <div class='col-sm-12 col-md-8 input-field'>
            <input type='text' id='firstname' maxlength="40" [attr.aria-describedby]="formErrors.firstName ? 'firstNameErrBlock':null"
              [ngClass]="{'text-error': formErrors.firstName}" class="form-control" formControlName='firstName'>
            <div *ngIf="formErrors.firstName" id='firstNameErrBlock' class="text-danger col-sm-12 col-md-10 qty-error">
              {{ formErrors.firstName }}
            </div>
          </div>
        </div>
        <div class='form-group'>
          <label class="col-sm-12 col-md-8" for='lastname' [ngClass]="{'error-field': formErrors.lastName}">Last name</label>          <br>
          <div class='col-sm-12 col-md-8 input-field'>
            <input type='text' id='lastname' [attr.aria-describedby]="formErrors.lastName ? 'lastNameErrBlock':null" maxlength="40" [ngClass]="{'text-error': formErrors.lastName}"
              class="form-control" formControlName='lastName'>
            <div *ngIf="formErrors.lastName" id='lastNameErrBlock' class="text-danger col-sm-12 col-md-10 qty-error">
              {{ formErrors.lastName }}
            </div>
          </div>
        </div>
        <div class='form-group'>
          <label class="col-sm-12 col-md-8" for='email' [ngClass]="{'error-field': formErrors.email}">Email</label> <br>
          <div class='col-sm-12 col-md-8 input-field'>
            <input type='text' id='email' [attr.aria-describedby]="formErrors.email ? 'emailErrBlock':null" maxLength="175" [ngClass]="{'text-error': formErrors.email}"
              class="form-control" formControlName='email'>
            <div *ngIf="formErrors.email" id='emailErrBlock' class="text-danger col-sm-12 col-md-10 qty-error">
              {{ formErrors.email }}
            </div>
          </div>
        </div>
        <div class='form-group'>
          <label class="col-sm-12 col-md-8" for='contact' [ngClass]="{'error-field': formErrors.phoneNumber}">Contact number</label>          <br>
          <div class='col-sm-12 col-md-8 input-field'>
            <input type='text' id='contact' [attr.aria-describedby]="formErrors.phoneNumber ? 'phoneNoErrBlock':null" [ngClass]="{'text-error': formErrors.phoneNumber}"
              (keypress)='contactChange($event)' (focus)='contactFocus($event)' (blur)='contactBlur($event)' maxLength="12"
              class="form-control" formControlName='phoneNumber'>
            <div *ngIf="formErrors.phoneNumber" id='phoneNoErrBlock' class="text-danger col-sm-12 col-md-10 qty-error">
              {{ formErrors.phoneNumber }}
            </div>
          </div>
        </div>
        <div>
          <h2 class='padding-top'>Product information</h2>
        </div>
        <div class='' *ngIf='!showProduct'>
          <p class='padding-top'> No products assigned</p>
        </div>
        <div *ngIf='showProduct'>
          <div class='row item-list' *ngFor="let prod of userSummaryProductModelArr; let i = index">
            <div class='col-sm-12 col-md-8 item-info'>
              <h2>{{prod.productName}}</h2>
              <div>
                <label class="data-label">Foundation account: </label><span> {{prod.fan}}</span><br>
                <label class="data-label">Wireless number: </label><span> {{prod.billingCtn}}</span>
                <p class="last-text" >{{prod.productDescription}}</p>
              </div>
              <!--<div class='user-product-info'>
              <label for="device-id" class="item-info">Device ID: </label><span> 13908adcf</span>
            </div>-->
              <ng-template let-item ngFor [ngForOf]="prod.extProperties.items">
                <div class='user-product-info data-label'>
                  <label class="data-label">{{item.name}}: </label><span>{{item.value}}</span>
                </div>
              </ng-template>

            </div>
          </div>
        </div>
        <hr _ngcontent-msy-10="" class="top-bottom">
        <div class="line-footer text-right">
          <button class="btn btn-secondary btn-go pull-right" (click)='updateUserInfo()' aria-label="Save." [checkImpersonator]='!userEditform.valid || csrPermissionSaveButton'>Save</button>
          <a href="javascript:void(0)" (click)='back()' class="btn btn-link">Cancel</a>
        </div>
      </form>
    </div>
  </div>
</div>
<app-mobile-pivot [pivots]="pivots"></app-mobile-pivot>